import Api from '@services/API';
import { getOS, getBrowser } from "@utils/getUserInfos";

/**
 * Service responsible for handling Authentication requests.
 * Follows the OAuth2 Password Grant flow.
 */
export default class OAuthService extends Api {

    /**
     * Base endpoint for authentication tokens.
     * Matches the backend route defined in Bruno collection (CT 01).
     * @type {String}
     */
    static base = '/erp/oauth/token';

    /**
     * Resource suffix (empty for the base token endpoint).
     * @type {String}
     */
    static resource = '';

    /**
     * @param {String} resource
     * @param {Object} options
     * @param {Object} http
     */
    constructor(resource, options = {}, http = null) {
        super(OAuthService.normalize(OAuthService.base, resource), options, http);
    }

    /**
     * Factory method to build the service instance.
     * @return {OAuthService}
     */
    static build() {
        return new this(this.resource);
    }

    /**
     * Authenticates the user using the Password Grant Type.
     * @param {Object} data - Objeto contendo as credenciais de acesso.
     * @param {String} data.username - Email ou login do usuário.
     * @param {String} data.password - Senha do usuário.
     * @param {String} [data.two_factor_code] - Código de verificação (opcional, usado no 2FA).
     * @returns {Promise} Axios response promise.
     */
    login(data) {
        if (!data || !data.username || !data.username.trim() || !data.password || !data.password.trim()) {
            throw new Error('Usuário e senha são obrigatórios');
        }

        const params = new URLSearchParams();

        params.append('grant_type', 'password');
        params.append('username', data.username.trim());
        params.append('password', data.password.trim());
        params.append('scope', '*');

        const systemOperational = getOS() || 'unknown';
        const browser = getBrowser() || 'unknown';

        params.append('system_operational', systemOperational);
        params.append('browser', browser);

        if (data.two_factor_code && data.two_factor_code.trim()) {
            params.append('two_factor_code', data.two_factor_code.trim());
        }

        return this.post('', params);
    }
}